import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import AiDashboard from './dashboard';
import AiReplay from './replay';

export default function Ai() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/dashboard`}>
        <AiDashboard />
      </Route>
      <Route path={`${path}/replay`}>
        <AiReplay />
      </Route>
      <Redirect path={path} to={`${path}/dashboard`} />
    </Switch>
  );
}
